const rankings = [
  { rank: 1, title: '庆余年第二季', type: '电视剧', hot: '987万', trend: 'up', change: '↑2' },
  { rank: 2, title: '狂飙', type: '电视剧', hot: '932万', trend: 'stable', change: '−' },
  { rank: 3, title: '与凤行', type: '电视剧', hot: '876万', trend: 'up', change: '↑1' },
  { rank: 4, title: '第二十条', type: '电影', hot: '821万', trend: 'up', change: '↑5' },
  { rank: 5, title: '墨雨云间', type: '电视剧', hot: '768万', trend: 'down', change: '↓2' },
  { rank: 6, title: '飞驰人生2', type: '电影', hot: '715万', trend: 'up', change: '↑3' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热播榜单</h2>
          <p className="text-sm text-foreground-500">全网用户正在追的影视排行，实时更新</p>
        </div>

        <div className="space-y-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-heading text-lg font-bold flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap flex-shrink-0">
                    {item.type}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="flex items-center gap-1 text-xs">
                  <i className="ri-fire-line text-accent-500"></i>
                  <span className="text-foreground-600 font-medium">{item.hot}</span>
                </div>
                <span className={`text-xs font-medium whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-foreground-400' : 'text-foreground-500'
                }`}>
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}